import React, { Component } from 'react';
import { connect } from 'react-redux';

let previousMessage = null;

export class TitleAnnouncer extends Component {
  constructor(props){
    super(props);

    this.state = {
        currentMessage: ''
    }
  }

  componentWillReceiveProps(nextProps) {
    const { title } = nextProps;
    if(title && title.currentMessage && title.currentMessage !== previousMessage) {
      previousMessage = title.currentMessage;
      setTimeout(()=>{this.setState({
        currentMessage: title.currentMessage
      })}, 50);
      setTimeout(()=>{this.setState({
        currentMessage: ''
      })}, 500)
    }
  }

  render() {
    const { currentMessage } = this.state;

    return (
      <div>
        <div id="announcer"  role="status" aria-live="polite" aria-atomic="true" className="skip">
          { currentMessage ? <span>{currentMessage}</span> : '' }
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ title }) => {
  return {
    title
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TitleAnnouncer);
